import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import StudentSidebar from './StudentSidebar';
import StudentTopBar from './StudentTopBar';
import AuthService from '../services/authService';
import { useLocation, useNavigate } from 'react-router-dom';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f9fafb;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${(p) => (p.$sidebarOpen ? '256px' : '80px')};
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f9fafb;
  padding: 24px;
`;

export default function StudentLayout({ children, title, requireSelection = true }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!requireSelection) return;

    const data = AuthService.getUser();
    const hasSelection = !!data?.selectedRegistration;
    if (!hasSelection && location.pathname !== '/app/select-course') {
      navigate('/app/select-course', { replace: true });
    }
  }, [requireSelection, navigate, location.pathname]);

  return (
    <Root>
      <StudentSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      <Main $sidebarOpen={sidebarOpen}>
        <StudentTopBar title={title} onMenuClick={() => setSidebarOpen(!sidebarOpen)} sidebarOpen={sidebarOpen} />
        <Content>{children}</Content>
      </Main>
    </Root>
  );
}
